import { render, staticRenderFns } from "./ProjectQuickAdd.vue?vue&type=template&id=ed4e0cc4&"
import script from "./ProjectQuickAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports